import { useAtomValue, useSetAtom } from "jotai";
import { currentStepObj, setCurrentStepFn, Step } from "../store";
import { steps } from "../steps";

export const useCurrentStep = () => {
  const currentStep = useAtomValue(currentStepObj);
  const setCurrentStep = useSetAtom(setCurrentStepFn);

  const stepLength = steps.length - 1; // since "ready" step is not included in the onboarding steps
  const currentStepIndex = steps.findIndex(
    (step: Step) => step.key === currentStep.key
  );
  const nextStep = steps[currentStepIndex + 1];
  const previousStep = steps[currentStepIndex - 1];
  const currentStepNumber = currentStepIndex + 1;
  const progressPercent = (currentStepNumber / stepLength) * 100;

  const goToNextStep = () => {
    // data add logic here may be
    setCurrentStep(nextStep);
  };

  // const skipStep = () => {
  //   // skip data logic here may be
  //   setCurrentStep(nextStep);
  // };

  const goToPreviousStep = () => {
    setCurrentStep(previousStep);
  };

  return {
    currentStep,
    currentStepNumber,
    goToNextStep,
    goToPreviousStep,
    // skipStep,
    stepLength,
    progressPercent,
  };
};
